/* eslint-disable */
// $FlowFixMe
// import * as digitalData from 'digitalData';

let _isSet = false;

/* istanbul ignore next */
function pgUnloadEvent() {
  if (window._T) {
    // $FlowFixMe
    _T.flags = _T.flags ? _T.flags : {};
    _T.flags.pgUnloadEvent = true;
  }
}

/* istanbul ignore next */
function collectionReady() {
  if (!_isSet) {
    window._T = window._T || {};

    if (typeof window._T.pageData === 'undefined') {
      window._T.pageData = [];
    }
    try {
      window._T.pageData.push(window.digitalData);
    } catch (e) {
      console.error('analytics: _T set error', e);
    }
    // _isSet = true;
  }
}

/* istanbul ignore next */
function startCountdown() {
  try {
    const pageName =
      window.digitalData.page &&
      window.digitalData.page.pageInfo &&
      window.digitalData.page.pageInfo.pageName
        ? window.digitalData.page.pageInfo.pageName
        : '';
    const beaconDelay =
      window._T && window._T.getPgBeaconDelay
        ? window._T.getPgBeaconDelay(pageName)
        : 5000;
    setTimeout(collectionReady, beaconDelay);
  } catch (e) {
    console.error('digital data _T error');
    collectionReady();
  }
}

export function initTHDObject() {
  if (typeof window.THD_GLOBAL === 'undefined') {
    window.THD_GLOBAL = {};
  }
  if (typeof window.THD === 'undefined') {
    window.THD = {};
    window.THD.Analytics = {};
  }
  if (typeof window.THD.Analytics === 'undefined') {
    window.THD.Analytics = {};
  }
}

/**
 * This function initializes the global digital data object
 */
export function initializeGlobalDDO(countDownTimer = 3000) {
  try {
    if (window.digitalData && typeof window.digitalData.init === 'function') {
      window.digitalData.init();
    }
    window.setTimeout(startCountdown, countDownTimer);
    // $FlowFixMe
    window.addEventListener('beforeunload', pgUnloadEvent);
    window.addEventListener('beforeunload', collectionReady);
  } catch (e) {
    console.error('GlobalDDO initialize failed', e);
  }
}

/**
 * This function sets the page object with the information of the page user lands on.
 */
export function setPageData(pageData) {
  if (window.digitalData) {
    window.digitalData.page = {
      ...window.digitalData.page,
      ...pageData
    };
    initializeGlobalDDO();
  }
}

/**
 * This function pushes the event object in the window.digital Object.
 */
export function eventReady(obj) {
  try {
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push(obj);
    if (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('AnalyticsDebug')
    ) {
      console.log('[Analytics event] ', obj);
    }
  } catch (e) {
    console.error('GlobalDDO event push failed', e);
  }
}
